var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ledger-list-filter"},[_c('hl-Datepicker',{attrs:{"name":"evenDate","label":"Til og med"},model:{value:(_vm.evenDate),callback:function ($$v) {_vm.evenDate=$$v},expression:"evenDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }